import { API, setAuthToken } from '../../../config/API.js';
import { GET_MILESTONE, SET_LOADING_MILESTONE, SET_PAGINATION_MILESTONE } from '../constant.js';

export const getMilestone = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_MILESTONE,
      payload: true,
    });
    API.get(`admin/about/journey?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_MILESTONE,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_MILESTONE,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_MILESTONE,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_MILESTONE,
          payload: 0,
        });
      });
  };
};

export const addMilestone = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/journey/add", params);
};

export const getDetailMilestone = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/about/journey/${code}`);
};

export const updMilestone = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/about/journey/edit", params);
};

export const delMilestone = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/about/journey/delete/" + code);
};
